module.exports = __webpack_public_path__ + "img/resumeuploaded.fdb24d16.svg";